
// 资质【提交预约】步骤的状态
export const PAPER_SUBMISSION = 'PaperSubmission';
// 电子合同
export const CONTRACT_TYPE_ELECTRON = 1;
// 纸质合同
export const CONTRACT_TYPE_PAPER = 0;

// 流程类型对应的value
export const PROCESS_VALUE = {
  // 申请已提交
  submit: 0,
  // 已发起预约
  reservation: 1,
  // 资料
  information: 2,
  // 电子签名
  signature: 3,
  // 适当性文件
  suitably: 4,
  // 认申购文件
  purchase: 5,
  // 打款
  drawn: 6,
  // 冷静期
  calm: 7,
  // 回访
  return: 8,
  // 回访待确认---回访未确认
  returnWaitSure: 9,
  // 回访确认
  returnSure: 10,
  // 份额确认失败
  shareFail: 11,
  // 份额确认
  shareSure: 12,
  // 份额确认中
  shareCentreSure: 13,
  // 份额已确认
  shareStopSure: 14,
}

// 输入密码
export const INPUT_PASSWORD = 1;
// 短信验证
export const MESSAGE_PASSWORD = 2;

// 双录按钮
export const BUTTON_STEP_RECORD = 'record';
// 签署按钮
export const BUTTON_STEP_SIGN = 'sign';

// 需要跳转人脸的处理
export const DOCUMENT_TYPE_LIST = [
  { code: '00', name: '身份证' },
  { code: '04', name: '港澳居民来往内地通行证' },
  { code: '0A', name: '台湾居民来往内地通行证' },
]
